import React, { useState } from 'react';

const PAGE_SIZES = [10, 25, 50];

/** Table with simple paging. columns: [{ label, align, render(row, index) }] */
export default function DetailTable({ columns, rows, empty = 'Nothing yet', pageSize: initial = 10 }) {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(initial);
  const pages = Math.max(1, Math.ceil(rows.length / size));
  const safe = Math.min(page, pages);
  const slice = rows.slice((safe - 1) * size, safe * size);

  return (
    <div className="dp-detail">
      <div className="dp-table-wrap">
        <table className="dp-table">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.label} className={c.align === 'right' ? 'num' : ''}>
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {slice.length ? (
              slice.map((row, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={i}>
                  {columns.map((c) => (
                    <td key={c.label} className={c.align === 'right' ? 'num' : ''}>
                      {c.render(row, (safe - 1) * size + i)}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="dp-muted">
                  {empty}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {rows.length > PAGE_SIZES[0] ? (
        <div className="dp-pager">
          <select
            className="dp-input dp-input--sm"
            value={size}
            onChange={(e) => {
              setSize(Number(e.target.value));
              setPage(1);
            }}
          >
            {PAGE_SIZES.map((n) => (
              <option key={n} value={n}>
                {n} / page
              </option>
            ))}
          </select>
          <span>
            {(safe - 1) * size + 1}–{Math.min(safe * size, rows.length)} of {rows.length}
          </span>
          <button type="button" className="dp-btn dp-btn--ghost dp-btn--sm" disabled={safe <= 1} onClick={() => setPage(safe - 1)}>
            Prev
          </button>
          <button type="button" className="dp-btn dp-btn--ghost dp-btn--sm" disabled={safe >= pages} onClick={() => setPage(safe + 1)}>
            Next
          </button>
        </div>
      ) : null}
    </div>
  );
}
